import React, { useState } from 'react';
import { ConfigDialog } from '../../dummies/ConfigDialog/ConfigDialog';
import templates from './templates';
import './ExpensesAnalyticsWidget.css';

export const EXPENSES_ANALYTICS_WIDTH = 400;
export const EXPENSES_ANALYTICS_HEIGHT = 350;

const DEFAULT_DATA = {
  categories: [
    { name: 'חשמל', amount: 4000, color: '#00C9E0' },
    { name: 'ניקיון', amount: 3000, color: '#4ADE80' },
    { name: 'תחזוקה', amount: 2000, color: '#FBBF24' },
    { name: 'אחר', amount: 1000, color: '#EF4444' }
  ]
};

export const ExpensesAnalyticsWidget = ({
  data = DEFAULT_DATA,
  freeText = '',
  onSave,
  template = 'Pie',
  title = 'פילוח הוצאות',
  showTitle = true
}) => {
  const [isConfigOpen, setIsConfigOpen] = useState(false);
  const [formData, setFormData] = useState(data);
  const [formFreeText, setFormFreeText] = useState(freeText);

  const handleSave = () => {
    if (onSave) onSave(formData, formFreeText);
    setIsConfigOpen(false);
  };

  const addCategory = () => {
    const newCategory = {
      name: '',
      amount: 0,
      color: `#${Math.floor(Math.random() * 16777215).toString(16)}`
    };
    setFormData(prev => ({
      ...prev,
      categories: [...prev.categories, newCategory]
    }));
  };

  const updateCategory = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      categories: prev.categories.map((cat, i) =>
        i === index ? { ...cat, [field]: value } : cat
      )
    }));
  };

  const removeCategory = (index) => {
    setFormData(prev => ({
      ...prev,
      categories: prev.categories.filter((_, i) => i !== index)
    }));
  };

  const Template = templates[template];

  if (!Template) {
    return <div>Template not found: {template}</div>;
  }

  return (
    <>
      <Template
        data={data}
        freeText={freeText}
        title={title}
        showTitle={showTitle}
        onSave={onSave}
        EXPENSES_ANALYTICS_WIDTH={EXPENSES_ANALYTICS_WIDTH}
        EXPENSES_ANALYTICS_HEIGHT={EXPENSES_ANALYTICS_HEIGHT}
      />

      <ConfigDialog
        open={isConfigOpen}
        onClose={() => setIsConfigOpen(false)}
        onConfirm={handleSave}
        title="הגדרות מדד הוצאות"
      >
        <div className="expenses-config">
          <div className="expenses-config__categories">
            <h3>קטגוריות הוצאות</h3>

            {formData.categories.map((category, index) => (
              <div key={index} className="expenses-config__category">
                <input
                  type="text"
                  placeholder="שם קטגוריה"
                  value={category.name}
                  onChange={(e) => updateCategory(index, 'name', e.target.value)}
                  className="expenses-config__input"
                />
                <input
                  type="number"
                  placeholder="סכום"
                  value={category.amount}
                  onChange={(e) => updateCategory(index, 'amount', parseInt(e.target.value) || 0)}
                  className="expenses-config__input"
                />
                <input
                  type="color"
                  value={category.color}
                  onChange={(e) => updateCategory(index, 'color', e.target.value)}
                  className="expenses-config__color"
                />
                <button
                  onClick={() => removeCategory(index)}
                  className="expenses-config__remove"
                >
                  ✕
                </button>
              </div>
            ))}

            <button
              onClick={addCategory}
              className="expenses-config__add"
            >
              + הוסף קטגוריה
            </button>
          </div>

          <div className="expenses-config__freetext">
            <h3>טקסט חופשי (אופציונלי)</h3>
            <textarea
              placeholder="הוסף טקסט חופשי... (לחץ Enter לשורה חדשה)"
              value={formFreeText}
              onChange={(e) => setFormFreeText(e.target.value)}
              className="expenses-config__textarea"
              rows={3}
            />
          </div>
        </div>
      </ConfigDialog>
    </>
  );
};